<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7929 0.792893C11.1834 0.402369 11.8166 0.402369 12.2071 0.792893L15.2071 3.79289C15.5976 4.18342 15.5976 4.81658 15.2071 5.20711L5.20711 15.2071C5.01957 15.3946 4.76522 15.5 4.5 15.5H1.5C0.947715 15.5 0.5 15.0523 0.5 14.5V11.5C0.5 11.2348 0.605357 10.9804 0.792893 10.7929L10.7929 0.792893ZM2.5 11.9142V13.5H4.08579L13.0858 4.5L11.5 2.91421L2.5 11.9142Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.793 8.20718L7.79297 5.20718L9.20718 3.79297L12.2072 6.79297L10.793 8.20718Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconPencil",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "16"
    }
  }
};
</script>
